import axios from "axios";

const TOKEN_KEY = "gl_admin_token";

export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
};
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const getToken = () => localStorage.getItem(TOKEN_KEY);

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Attach bearer token (robust on custom domains where cross-site cookies may be blocked)
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
